import script from "./competenzeAwards.vue?vue&type=script&setup=true&lang=js"
export * from "./competenzeAwards.vue?vue&type=script&setup=true&lang=js"

import "./competenzeAwards.vue?vue&type=style&index=0&id=0d140beb&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d140beb"]])

export default __exports__